export default {
  testdrive: state => state.testdrive
}



// WEBPACK FOOTER //
// ./src/store/modules/testdrive/getters.js